import { render, staticRenderFns } from "./TheSlides.vue?vue&type=template&id=30a52a5c&"
import script from "./TheSlides.vue?vue&type=script&lang=js&"
export * from "./TheSlides.vue?vue&type=script&lang=js&"
import style0 from "./TheSlides.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports